import { ApiClient } from "@/api";
import { AmplitudeEvents } from "@/events/AmplitudeEvents";
import { EventBus } from "@/services/eventBus";
import { IDatasetDownloadedEvent } from "@/events/IDatasetDownloadedEvent";
import { IDatasetViewed } from "@/events/IDatasetViewed";

EventBus.$on(
  [AmplitudeEvents.DatasetDownloaded],
  (event: IDatasetDownloadedEvent) => {
    ApiClient.Dataset.markAsDownloaded(event.dataset_hash);
  }
);

EventBus.$on([AmplitudeEvents.DatasetViewed], (event: IDatasetViewed) => {
  ApiClient.Dataset.markAsViewed(event.dataset_hash);
});
